// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__13LZL","description":"PatientConsentPreview_description__3R1kr"};